// src/components/HelicopterSidebar.js

import React from 'react';
import "../views/home.css";
import '../components/manage-helicopter-card.css'
import Heli from '../assest/HYla7Hv.png'
import useOnClickOutside from "../components/use-onclick-outside";
import HelicopterIconBlack from "../components/helicopter-icon-black";
import HelicopterIconGreen from "../components/helicopter-icon-green";
import HelicopterIconRed from "../components/helicopter-icon-red";
import HelicopterIconYellow from "../components/helicopter-icon-yellow";
import HelicopterIconStack from "../components/helicopter-icon-stack";
import HelicopterIconStackHover from "../components/helicopter-icon-stack-hover";
import NotificationHover from "../components/notification-hover";
import HelpCenterPopUp from "../components/help-center-pop-up";
import ProfilePopUp from "../components/profile-pop-up";

const HelicopterSidebar = ({
  helicopterData,
  authRole,
  currentFlightIndex,
  handlePrevFlight,
  handleNextFlight,
  updateHelicopterStatus,
  handleVisibilityToggle,
  closePopup,
  t
}) => {
  return (
    <div id="left" className="sidebar flex-center left collapsed">
      <div className="sidebar-content rounded-rect flex-center">
        <div className="manage-helicopter-card-container manage-helicopter-card-root-class-name">
          <img alt="image" src={helicopterData.image} className="manage-helicopter-card-image" />
          <div className="manage-helicopter-card-content2">
            <div className="manage-helicopter-card-container01">
              <div className="manage-helicopter-card-container02">
                <div className="manage-helicopter-card-container03">
                  <span className="manage-helicopter-card-text">{helicopterData && helicopterData.heliId}</span>
                  <span className="manage-helicopter-card-text01">{helicopterData && helicopterData.title}</span>
                </div>
                <div className="manage-helicopter-card-einsatzbereit-in">
                  <span className="manage-helicopter-card-text02">{t("helicopter.ready")}:</span>
                  {(authRole === "admin" || (authRole === "user" && helicopterData.hasAccess)) ? (
                    <select
                      id="select_box"
                      onFocus={e => e.target.size = 8}
                      onBlur={e => e.target.size = 1}
                      className={`select-option-status status${helicopterData.Einsatzbereit_in}`}
                      onChange={(e) => {
                        e.target.size = 1;
                        updateHelicopterStatus(e.target.value, helicopterData);
                      }}
                    >
                      <option className="select-option-status" hidden value="">
                        {helicopterData.Einsatzbereit_in == "1" ? "15 Min" :
                          helicopterData.Einsatzbereit_in == "2" ? "30 Min" :
                            helicopterData.Einsatzbereit_in == "3" ? "60 Min" :
                              helicopterData.Einsatzbereit_in == "4" ? "2 Std" :
                                helicopterData.Einsatzbereit_in == "5" ? "3 Std" :
                                  helicopterData.Einsatzbereit_in == "6" ? "Im Einsatz" :
                                    helicopterData.Einsatzbereit_in == "7" ? "Abgemeldet N/A" :
                                      helicopterData.Einsatzbereit_in == "8" ? "Im Betrieb" : ""}
                      </option>
                      <option className="select-option-status1" value="1">15 Min</option>
                      <option className="select-option-status2" value="2">30 Min</option>
                      <option className="select-option-status3" value="3">60 Min</option>
                      <option className="select-option-status4" value="4">2 Std</option>
                      <option className="select-option-status5" value="5">3 Std</option>
                      <option className="select-option-status6" value="6">Im Einsatz</option>
                      <option className="select-option-status7" value="7">Abgemeldet N/A</option>
                      <option className="select-option-status8" value="8">Im Betrieb</option>
                    </select>
                  ) : (
                    <span className={`text-center select-option-status status${helicopterData.Einsatzbereit_in}`}>
                      {helicopterData.Einsatzbereit_in == "1" ? "15 Min" :
                        helicopterData.Einsatzbereit_in == "2" ? "30 Min" :
                          helicopterData.Einsatzbereit_in == "3" ? "60 Min" :
                            helicopterData.Einsatzbereit_in == "4" ? "2 Std" :
                              helicopterData.Einsatzbereit_in == "5" ? "3 Std" :
                                helicopterData.Einsatzbereit_in == "6" ? "Im Einsatz" :
                                  helicopterData.Einsatzbereit_in == "7" ? "Abgemeldet N/A" :
                                    helicopterData.Einsatzbereit_in == "8" ? "Im Betrieb" : ""}
                    </span>
                  )}
                </div>
              </div>
              <div className="manage-helicopter-card-container13">
                <span className="manage-helicopter-card-text">{t("helicopter.liveURL")}:</span>
                <span className="manage-helicopter-card-text12">{helicopterData && helicopterData.LiveFeedURL ? helicopterData.LiveFeedURL : '-'}</span>
              </div>
              {authRole === "admin" && (
                <div className="manage-helicopter-card-container14">
                  <span className="manage-helicopter-card-text">{t("helicopter.visibility")}:</span>
                  <div className="toggle-switch">
                    <input
                      type="checkbox"
                      id="visibility-toggle"
                      className="toggle-switch-checkbox"
                      checked={helicopterData.visibility !== false}
                      onChange={() => handleVisibilityToggle(helicopterData.id)}
                    />
                    <label className="toggle-switch-label" htmlFor="visibility-toggle">
                      <span className="toggle-switch-inner"></span>
                      <span className="toggle-switch-switch"></span>
                    </label>
                  </div>
                </div>
              )}
            </div>
            <div className="manage-helicopter-card-container04">
              <div className="manage-helicopter-card-container05">
                <div className="manage-helicopter-card-container06">
                  <span className="manage-helicopter-card-text03">{t("helicopter.operator")}:</span>
                  <span className="manage-helicopter-card-text04">{helicopterData && helicopterData.Betreiber}</span>
                  <span className="manage-helicopter-card-text04" style={{ "min-height": "auto" }}>
                    <span className="manage-helicopter-card-text03">{t("helicopter.number")}: <br /></span>
                    {helicopterData.number}
                  </span>
                </div>
                <div className="manage-helicopter-card-container07">
                  <span className="manage-helicopter-card-text05">{t("helicopter.watertank")}:</span>
                  <span className="manage-helicopter-card-text06">{helicopterData && helicopterData.Wassertank}</span>
                </div>
              </div>
              <div className="manage-helicopter-card-container08">
                <div className="manage-helicopter-card-container09">
                  <span className="manage-helicopter-card-text07">
                    <span className="">{t("helicopter.capacity")}:</span>
                    <span className="manage-helicopter-card-text09"></span>
                  </span>
                  <span className="manage-helicopter-card-text10">{helicopterData && helicopterData.Fassungsvermogen}</span>
                </div>
                <div className="manage-helicopter-card-container10">
                  <span className="manage-helicopter-card-text11">{t("helicopter.type")}:</span>
                  <span className="manage-helicopter-card-text12">{helicopterData && helicopterData.type}</span>
                </div>
              </div>
            </div>
          </div>

          {/* New Section for Flight Navigation */}
          <div className="flight-navigation">
            {helicopterData.flights && helicopterData.flights.length > 0 && (
              <>
                <button 
                  onClick={handlePrevFlight} 
                  className="flight-nav-btn small-red-btn"
                  disabled={currentFlightIndex <= 0} // Disable if no previous flight
                >
                  <i className="fas fa-chevron-left"></i> {/* Font Awesome left arrow icon */}
                </button>
                <span className="flight-date">
                  {new Date(
                    (helicopterData.flights[currentFlightIndex] || helicopterData.flights[helicopterData.flights.length - 1]).lastUpdated
                  ).toLocaleString()}
                </span>
                <button 
                  onClick={handleNextFlight} 
                  className="flight-nav-btn small-red-btn"
                  disabled={currentFlightIndex >= helicopterData.flights.length - 1} // Disable if no next flight
                >
                  <i className="fas fa-chevron-right"></i> {/* Font Awesome right arrow icon */}
                </button>
              </>
            )}
          </div>
        </div>
        <div
          id="trackId"
          onClick={e => closePopup(helicopterData.trackId)}
          className="add-helicopter-container-close-button"
          data-trackid={helicopterData.trackId}
        >
          <svg
            viewBox="0 0 1024 1024"
            className="add-helicopter-container-icon"
          >
            <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default HelicopterSidebar;